export default "__VITE_ASSET__C28$jC6W__"